import { styled, Box } from '@mui/material';

interface IActionBoxStyledProps {
  attrs: {
    bgColor: string;
  };
}

export const ActionBoxStyled = styled(Box)<IActionBoxStyledProps>(
  ({ theme, attrs: { bgColor } }) => ({
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    backgroundColor: bgColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    color: theme.palette.white.main,
  }),
);
